import { render, staticRenderFns } from "./ImageLibraryModal.vue?vue&type=template&id=580a874a&scoped=true&"
import script from "./ImageLibraryModal.vue?vue&type=script&lang=js&"
export * from "./ImageLibraryModal.vue?vue&type=script&lang=js&"
import style0 from "./ImageLibraryModal.vue?vue&type=style&index=0&id=580a874a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580a874a",
  null
  
)

export default component.exports